"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findRuleByDeepness = exports.findRuleByClosestAncestor = exports.findRuleBySameDeepness = exports.doesEndWithState = void 0;
function doesEndWithState(newSelector) {
    return newSelector.lastIndexOf(':') > newSelector.lastIndexOf('::') + 1;
}
exports.doesEndWithState = doesEndWithState;
// find by same deepness - sort by abc:
function isSameDeepnessAndMinimalMatch(target, newSelector) {
    var targetParts = target.split('::');
    var newSelectorParts = newSelector.split('::');
    if (targetParts.length !== newSelectorParts.length) {
        return false;
    }
    return newSelectorParts.findIndex(function (part, index) { return part !== targetParts[index]; }) > 0;
}
var findRuleBySameDeepness = function (selectors, newSelector) {
    var abcDeepness = 0;
    var sameDeepnessFound = false;
    selectors.forEach(function (selector, index) {
        if (isSameDeepnessAndMinimalMatch(selector, newSelector)) {
            sameDeepnessFound = true;
            if (selector < newSelector) {
                abcDeepness = index;
            }
        }
    });
    if (sameDeepnessFound) {
        if (abcDeepness === 0 && selectors[0] > newSelector) {
            return -1;
        }
        else if (abcDeepness === 0) {
            return 0;
        }
        return abcDeepness;
    }
    return undefined;
};
exports.findRuleBySameDeepness = findRuleBySameDeepness;
function findMatchSize(target, newSelector) {
    var targetParts = target.split('::');
    var newSelectorParts = newSelector.split('::');
    if (targetParts.length >= newSelectorParts.length) {
        return 0;
    }
    return newSelectorParts.findIndex(function (part, index) { return part !== targetParts[index]; });
}
var findRuleByClosestAncestor = function (selectors, newSelector) {
    var maxMatch = 0;
    var match;
    // find by closest ancestor:
    selectors.forEach(function (selector, index) {
        var matchSize = findMatchSize(selector, newSelector);
        if (matchSize > maxMatch) {
            maxMatch = matchSize;
            match = index;
        }
    });
    return match;
};
exports.findRuleByClosestAncestor = findRuleByClosestAncestor;
var findRuleByDeepness = function (selectors, newSelector) {
    // find by deepness - TODO remove?
    var deepnessArray = selectors.map(function (selector) {
        return (selector.match(/::/g) || []).length;
    });
    var selectorDeepness = (newSelector.match(/::/g) || []).length;
    // take last of same deepness:
    for (var i = deepnessArray.length - 1; i >= 0; i--) {
        if (deepnessArray[i] <= selectorDeepness) {
            return i;
        }
    }
    return undefined;
};
exports.findRuleByDeepness = findRuleByDeepness;
//# sourceMappingURL=rule-order-utils.js.map